export const getIntentTargetingStyles = () => ({
  intentTarget: {
    marginTop: 20,
  },
  intentTargetOptions: {
    marginTop: 6,
  },
  title: {
    '& span': {
      fontWeight: 600,
    },
  },
  errormessage: {
    color: '#a80000',
  },
});
